// src/components/PlayersView.js
import React, { useMemo, useState } from 'react';
import { fetchJson } from '../utils/api';
import { getTeamIdFromPlayer } from '../utils/player';
import Button from './ui/Button';

function PlayersView({ teams = [], players = [], onPlayersChanged }) {
    const [selectedPlayerId, setSelectedPlayerId] = useState(null);
    const [formData, setFormData] = useState({ name: '', link: '', teamId: '' });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Spieler aktualisieren
    const updatePlayer = () => {
        if (!selectedPlayerId) return;

        const payload = {
            name: formData.name,
            link: formData.link,
            teamId: formData.teamId ? formData.teamId : null,
        };

        fetchJson(`/api/players/${selectedPlayerId}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then(() => {
                onPlayersChanged(); // Spieler- und Teamliste neu laden
                resetForm();
            })
            .catch((err) => console.error('Fetch-Fehler:', err));
    };

    // Spieler löschen
    const deletePlayer = () => {
        if (!selectedPlayerId) return;

        fetchJson(`/api/players/${selectedPlayerId}`, {
            method: 'DELETE',
        })
            .then(() => {
                onPlayersChanged(); // Spieler- und Teamliste neu laden
                resetForm();
            })
            .catch((err) => console.error('Fetch-Fehler:', err));
    };

    // Formular zurücksetzen
    const resetForm = () => {
        setSelectedPlayerId(null);
        setFormData({ name: '', link: '', teamId: '' });
    };

    const teamsById = useMemo(
        () => Object.fromEntries(teams.map((team) => [team.id, team])),
        [teams]
    );

    return (
        <div>
            <h3>Spielerübersicht</h3>
            <ul>
                {players.map((player) => (
                    <li key={player.id}>
                        <div>
                            {(() => {
                                const teamId = getTeamIdFromPlayer(player);
                                const teamName = teamId
                                    ? teamsById[teamId]?.name || player.team?.name
                                    : null;
                                return `${player.name} (Team: ${teamName || 'Kein Team'})`;
                            })()}{' '}
                            <Button
                                size="sm"
                                onClick={() => {
                                    // Formular mit aktuellen Werten befüllen
                                    setSelectedPlayerId(player.id);
                                    setFormData({
                                        name: player.name,
                                        link: player.link,
                                        teamId: getTeamIdFromPlayer(player) || '',
                                    });
                                }}
                            >
                                Bearbeiten
                            </Button>
                        </div>

                        {selectedPlayerId === player.id && (
                            <div style={{ marginTop: '10px', border: '1px solid #ccc', padding: '10px' }}>
                                <h4>Spieler bearbeiten</h4>
                                <label>
                                    Name:
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                    />
                                </label>
                                <label>
                                    Liveansicht-URL:
                                    <input
                                        type="url"
                                        name="link"
                                        value={formData.link}
                                        onChange={handleInputChange}
                                    />
                                </label>
                                <label>
                                    Team:
                                    <select
                                        name="teamId"
                                        value={formData.teamId || ''}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">Kein Team</option>
                                        {teams.map((t) => (
                                            <option key={t.id} value={t.id}>
                                                {t.name}
                                            </option>
                                        ))}
                                    </select>
                                </label>

                                <div style={{ marginTop: '10px' }}>
                                    <Button size="sm" onClick={updatePlayer}>Speichern</Button>
                                    <Button size="sm" variant="danger" onClick={deletePlayer} style={{ marginLeft: '10px' }}>
                                        Löschen
                                    </Button>
                                    <Button size="sm" onClick={resetForm} style={{ marginLeft: '10px' }}>
                                        Abbrechen
                                    </Button>
                                </div>
                            </div>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default PlayersView;